const { getElement } = window.BAO.Utils

export class SiteModal extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  constructor () {
    super()

    this.modals = getElement('site-modals')
    if (!this.modals) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-modals> element to work`,
      )
    }

    this.inert = true
    this._isOpen = false
  }

  connectedCallback () {
    super.connectedCallback()
  }

  get key () {
    return this.getAttribute('key')
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeModalClass, val)

    if (val) {
      if (!this.hasAttribute('open')) {
        this.inert = false
        this.showModal()
      }
    } else {
      if (this.hasAttribute('open')) {
        this.inert = true
        this.close()
      }
    }
  }

  get config () {
    return {
      classes: {
        activeModalClass: 'mod-Modal-active',
      },
    }
  }
}

customElements.define('site-modal', SiteModal, { extends: 'dialog' })
